module.exports = __webpack_public_path__ + "static/recruitment_extra_wide-46df25b3a55f703556b8fc6e7f14b086.jpg";